import { ShiftInterface } from '../../../interfaces/shift.interface';

export class UpdateShifts {
    public static readonly type = '[JobsPlacements] Update shifts';

    constructor(public shifts: ShiftInterface[]) {}
}
